import { MapMarker } from './map.marker';

export abstract class MapCluster {
    public id: number; // Identificador secuencial
    public mapComponent: any;
    public map: any;   // Mapa nativo
    public maxZoom: number; // Zoom mínimo para mostrar marcadores sueltos

    constructor(id: number, mapComponent: any, map: any, maxZoom: number) {
        this.id = id;
        this.mapComponent = mapComponent;
        this.map = map;
        this.maxZoom = maxZoom;
    }

    abstract addMarker(marker: MapMarker): any;
    abstract removeMarker(marker: MapMarker): any;
    abstract removeMarkers(): any;
    abstract repaint(): any;
}
